import { all } from "redux-saga/effects";
import authWatcher from "./authentication/saga";
import profileWatcher from "./profile/saga";
import statusWatcher from "./status/saga";
import complaintWatcher from "./complaints/saga";
import mockWatcher from "./mock/saga";
import locationsWatcher from "./locations/saga";
import callsWatcher from "./calls/saga";

export default function* rootSaga() {
  yield all([
    authWatcher(),
    callsWatcher(),
    locationsWatcher(),
    profileWatcher(),
    statusWatcher(),
    complaintWatcher(),
    mockWatcher(),
  ]);
}
